// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as AdjustFareRepoManager from "./AdjustFareRepoManager.bs.js";

function fetchFare(crn, fareType, onSuccess, onFailure, country) {
  var RepoInstance = AdjustFareRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchFare, crn, fareType, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function previewFareChanges(param, onSuccess, onFailure, country) {
  var RepoInstance = AdjustFareRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.previewFareChanges, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function updateFare(param, onSuccess, onFailure, country) {
  var RepoInstance = AdjustFareRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.updateFare, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function getIncidentalChargeTypes(onSuccess, onFailure, country) {
  var RepoInstance = AdjustFareRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.getIncidentalChargeTypes, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  fetchFare ,
  previewFareChanges ,
  updateFare ,
  getIncidentalChargeTypes ,
  
}
/* AdjustFareRepoManager Not a pure module */
